import type { OnboardingContent } from './types';

export const OPS_ONBOARDING: OnboardingContent = {
  role: 'OPS',
  roleLabel: 'Quản lý vận hành',
  tagline: 'Đọc kế hoạch nhân sự cho kho của bạn — chuẩn bị ca làm ngày mai.',
  steps: [
    {
      id: 'ops-1-welcome',
      title: 'Chào mừng tới Kế hoạch nhân sự v2',
      body:
        'Đây là công cụ giúp bạn biết ngày mai kho cần bao nhiêu người, bao nhiêu giờ làm. Bạn không cần tự tính — hệ thống đã dự báo sẵn dựa trên đơn lịch sử và sự kiện trong tuần.',
      bullets: [
        'Cá nhân hóa theo vai trò Quản lý vận hành',
        'Mở lại hướng dẫn bất cứ lúc nào ở mục Trợ giúp',
      ],
    },
    {
      id: 'ops-2-warehouse',
      title: 'Chọn kho của bạn ở thanh trên cùng',
      body:
        'Phía trên màn hình có nút chọn Quốc gia và Kho. Hãy chọn kho bạn đang quản lý. Mọi dự báo và báo cáo bên dưới sẽ tự lọc theo kho đó.',
      bullets: [
        'Quốc gia: VN / TH / PH',
        'Kho: chọn theo mã kho bạn phụ trách',
      ],
    },
    {
      id: 'ops-3-forecast',
      title: 'Xem dự báo 14 ngày tới',
      body:
        'Mở "Dự báo" để thấy biểu đồ workload hằng ngày. Cột đỏ là ngày sale lớn, cột vàng là ngày cao điểm — cần xếp ca dày hơn. Cột xám là ngày bình thường.',
      ctaLabel: 'Mở Dự báo',
      ctaHref: '/planner/forecast',
    },
    {
      id: 'ops-4-warehouse-report',
      title: 'Xem báo cáo workload theo kho',
      body:
        'Mục "Kho" trong Dự báo cho bạn số ca cần xếp, số người cần có mặt cho mỗi ngày. Đây là số chính để bạn lên lịch ca và báo cho team.',
      ctaLabel: 'Báo cáo kho',
      ctaHref: '/planner/forecast/warehouse',
    },
    {
      id: 'ops-5-help',
      title: 'Cần xem lại? Vào Trợ giúp',
      body:
        'Bất cứ lúc nào bạn quên thao tác, bấm "Trợ giúp" ở thanh bên trái. Bạn có thể chạy lại hướng dẫn này, hoặc xem từng tác vụ cụ thể.',
      ctaLabel: 'Mở Trợ giúp',
      ctaHref: '/help',
    },
  ],
};
